(function () {
'use strict';

function generalInit(){
	(function($){
	
		function myScrollTo( $target, $trigger ){
			if( $target.length ) {
				var offTop = $target.position().top;
				
				if( $trigger.attr('data-ignore-header') === undefined ){ 
					offTop -= $('#site-header').outerHeight();
					offTop -= 40;
				}
				
				var animationTime = Math.abs( offTop - $(window).scrollTop() ) * 1.2;
				
				$('html, body').stop().animate( {scrollTop: offTop}, animationTime );
			}
		}
		
		$('a[href="#"]').click(function(e){
			e.preventDefault();
		});
		
		$('a[data-scroll-down]').click(function(e){
			
			var $target = $( $(this).attr('href') );
			if( !$target.length ) $target = $(this).closest('section').next('section');
			
			if( $target.length ) e.preventDefault();
			
			myScrollTo($target, $(this) );
			
		});
	
		//add simple support for background images:
		$(document).on('lazybeforeunveil', function(e){
	    var bg = $(e.target).attr('data-bg');
	    if(bg){
	      e.target.style.backgroundImage = 'url(\'' + bg + '\')';
	    }
		});
		
	})(jQuery);
}

function slidersInit() {

	(function ($) {

		// $('#home-slider').slick({
		// 	loop: true,
		// 	dots: false,
		// 	// autoplay: true,
		// 	infinite: true,
		// 	slidesToShow: 3,
		// 	slidesToScroll: 1,
		// 	arrows: false,
		// 	centerPadding:'50px'


		// 	// responsive: [
		// 	// 	{
		// 	// 		breakpoint: 800,
		// 	// 		settings: {
		// 	// 			slidesToShow: 1,
		// 	// 			infinite: true
		// 	// 		}
		// 	// 	}
		// 	// ]

		// });

		//slider on front_page
		$(".owl-1").owlCarousel({
			responsive: {
				0: {
					items: 1,
					stagePadding: 0,
					margin: 20
				},
				400: {
					items: 2,
					stagePadding: 0,
					margin: 20
				},
				640: {
					items: 1,
					stagePadding: 30,
					margin: 20
				},
				700: {
					items: 1,
					stagePadding: 70,
					margin: 20
				},
				980: {
					items: 2,
					stagePadding: 20,
					margin: 20
				},
				1100: {
					items: 2,
					stagePadding: 50,
					margin: 30,
				},
				1360: {
					items: 2,
					stagePadding: 70,
					margin: 30,
				},
				1600: {
					items: 3,
					stagePadding: 20,
					margin: 30,
				}
			},

			loop: true,

			autoplay: 2000,
			stopOnHover: true,
			smartSpeed: 1000,
			slideTransition: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
			dots: false,
			autoHeight: true
		});

		///slider uslugi

		$(".slider-big").owlCarousel({
			items: 1,
			nav: true,
			loop: true,
			autoplay: 2000,
			stopOnHover: true,
			smartSpeed: 1000,
			slideTransition: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
			dots: true,
			// autoHeight: true
		});


		$(".owl-files").owlCarousel({
			items: 6,
			margin: 30,
			loop: true,
			autoplay: 2000,
			stopOnHover: true,
			smartSpeed: 1000,
			slideTransition: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
			dots: true,
			autoHeight: true,
			responsive: {

				0: {
					items: 3,
					stagePadding: 0,
					margin: 20
				},
				500: {
					items: 4,
					stagePadding: 0,
					margin: 20
				},

				700: {
					items: 6,

					margin: 20
				},
			},
		});



	})(jQuery);

}

function menuInit(){
	
	(function($){

	var menu_breakpoint = 'menu';
	
	function fixedNav(){
		
		if( ! $('body').hasClass('fixed-nav') ) return;
		
		var scrolltop = $(window).scrollTop();
		var hTop = 0;
		
	
		if(scrolltop > hTop && !$('body').hasClass('scrolled') ){
			$('body').addClass('scrolled');
		}
		if(scrolltop <= hTop && $('body').hasClass('scrolled') ){
			$('body').removeClass('scrolled');
		}
			
	}
	
	function menuEvents(){
		
		$('#site-header .menu li.menu-item-has-children').append('<div class="arrow">');
	
		$('#site-header .menu li.menu-item-has-children .arrow').click(function(){
			$(this).siblings('.sub-menu').stop().slideToggle(200);
		});
		
		$('#site-header .menu li.menu-item-has-children > a[href="#"]').click(function(){
			if( ! Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$(this).siblings('.sub-menu').stop().slideToggle(200);
			}
		});
		
		$('#site-header .menu .menu a:not([href="#"])').click(function(){
			if( ! Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$('#site-header .menu-wrap').removeClass('active');
			}
		});
		
		$('#hamburger').click(function(){
			if( ! Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$('#site-header .menu-wrap').toggleClass('active');
			}
		});
		
		$('#site-header .menu li.menu-item-has-children').hover(function(){
			if( Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$(this).children('.sub-menu').stop().fadeIn(200);
			}
		}, function(){
			if( Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$(this).children('.sub-menu').stop().fadeOut(200);
			}
		});
		
		$(window).on('changed.zf.mediaquery', function() {
		  if(Foundation.MediaQuery.atLeast('large')){
				$('#site-header .menu .sub-menu').hide();
			}
		});
		
	}
	
	fixedNav();
	menuEvents();
	
	$(window).scroll(function(){
		requestAnimationFrame(function(){
			fixedNav();
		});
	});
	 
	})(jQuery);
	
}

function galleryInit(){
	(function($){
		
		$('.post-content .gallery').each(function(i){
			$(this).find('.gallery-item').each(function(){
				
				$(this).find('.gallery-icon a').attr('data-fancybox', 'post-gallery-' + i);
				
				if( $(this).find('.wp-caption-text') ){
					var captionText = $(this).find('.wp-caption-text').html();
					$(this).find('.gallery-icon a').attr('data-caption', captionText);
				}
			});
		});
		
	})(jQuery);
}

function loadMoreInit(){
	(function($){
		
		function ajax_show_more($wrapper, template, btn){
		
	    if( btn.hasClass('is-loading') ) return;
	
	
	    var data = {
	    	'action': 'loadmore',
        'query': wp_params.posts, // that's how we get wp_params from wp_localize_script() function
        'page' : wp_params.current_page,
        'template' : template
	    }; 
	
	    $.ajax({
	        url : wp_params.ajax_url, // AJAX handler
	        data : data,
	        type : 'POST',
	        beforeSend : function ( ) {
		        btn.addClass('is-loading');
	        },
	        success : function( data ){
	          if( data ) { 

              var disp = $wrapper.children().first().css('display');

              $wrapper.append(data);
              $wrapper.find('.ajax-loaded').css({display: disp}).hide();
              $wrapper.find('.ajax-loaded').fadeIn(400).removeClass('ajax-loaded');

              btn.removeClass('is-loading');

              wp_params.current_page++;

              if ( wp_params.current_page == wp_params.max_page ) {
                  btn.addClass('fading').fadeOut(400);
                  btn.removeClass('is-loading').addClass('no-posts');
              }
              // you can also fire the "post-load" event here if you use a plugin that requires it
              $( document.body ).trigger( 'post-load' );
	
	          } else {
              btn.addClass('fading').fadeOut(400);
              btn.removeClass('is-loading').addClass('no-posts');
	          }
	        }
	    });
		}
		
		
		// Preload icon
		$('[data-loadmore]').addClass('is-loading');
		setTimeout(function(){
			$('[data-loadmore]').removeClass('is-loading');
		}, 20);
		
    $('[data-loadmore]').on('click', function(){
      var $wrapper = $( $(this).attr('data-wrap') );
      var btn = $(this);
      var template = $(this).attr('data-template');
      
      ajax_show_more($wrapper, template, btn);
    });
		
	})(jQuery);
}

(function($){
	
	$(document).foundation();
		
	$(document).ready(function(){

		generalInit();
		slidersInit();
		menuInit();
		galleryInit();
		loadMoreInit(); 

	});
	
	// Kod JS w modułach, tu tylko uruchamiamy
	
})(jQuery);

}());
